export default function AppSection() {
  return (
    <section id="app" className="w-full py-14 md:py-20 bg-background-950 relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20abstract%20mobile%20technology%20composition%20with%20subtle%20crimson%20gradient%20glow%2C%20minimal%20geometric%20phone%20silhouette%20shapes%2C%20app%20promotion%20dark%20backdrop%2C%20warm%20dramatic%20atmosphere%2C%20no%20text%20or%20people&width=1400&height=500&seq=app-bg-hlv&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-background-950/80" />
      </div>

      <div className="relative z-10 max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-14">
          <div className="flex-1 text-center lg:text-left">
            <span className="inline-block px-3 py-1 rounded-full bg-accent-500/20 border border-accent-400/30 text-accent-300 text-xs font-medium mb-4">
              随时随地 · 掌上黑料
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-extrabold text-white mb-4">
              移动端入口
            </h2>
            <p className="text-sm md:text-base text-white/70 leading-relaxed max-w-lg mx-auto lg:mx-0 mb-6">
              黑料视频移动端适配已全面上线。通过手机浏览器访问即可获得与桌面端一致的流畅体验。无需下载任何应用，即开即看，24小时黑料视频随时掌握。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#hero"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-white font-semibold text-sm rounded-lg transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-smartphone-line text-lg" />
                手机端立即访问
              </a>
              <a
                href="#carousel"
                className="inline-flex items-center gap-2 px-6 py-3 bg-white/10 hover:bg-white/20 text-white font-medium text-sm rounded-lg border border-white/20 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-compass-3-line text-lg" />
                浏览最新内容
              </a>
            </div>
          </div>

          <div className="shrink-0">
            <div className="relative w-[220px] h-[440px] md:w-[260px] md:h-[520px] rounded-3xl border-2 border-white/20 overflow-hidden shadow-2xl bg-background-900">
              <div className="absolute top-0 left-0 right-0 h-16 bg-background-800 flex items-center justify-center">
                <span className="text-white/80 text-xs font-medium">黑料视频</span>
              </div>
              <div className="pt-20 px-4 space-y-3">
                {[1, 2, 3, 4].map((n) => (
                  <div key={n} className="flex gap-3 items-start">
                    <div className="w-10 h-10 rounded-md bg-background-700 shrink-0" />
                    <div className="flex-1">
                      <div className="h-2.5 w-3/4 rounded bg-background-600" />
                      <div className="h-2 w-full rounded bg-background-700 mt-1.5" />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}